import { DateTime } from 'luxon'
import { useEffect, useMemo, useRef, useState } from 'react'

const getTimeLeft = (endTime: number) => {
  const currentTime = DateTime.now().toMillis()
  return Math.max(0, Math.floor((endTime - currentTime) / 1000))
}

export const useCountdown = (endTime: number) => {
  const [timeLeftInSeconds, setTimeLeftInSeconds] = useState(
    getTimeLeft(endTime)
  )
  const intervalRef = useRef<NodeJS.Timeout>(null)

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTimeLeftInSeconds(getTimeLeft(endTime))
    }, 50)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [endTime])

  useEffect(() => {
    if (timeLeftInSeconds === 0 && intervalRef.current) {
      clearInterval(intervalRef.current)
    }
  }, [timeLeftInSeconds])

  return useMemo(() => {
    const minutes = Math.floor(timeLeftInSeconds / 60)
    const seconds = timeLeftInSeconds % 60
    return `${minutes}:${seconds.toString().padStart(2, '0')}`
  }, [timeLeftInSeconds])
}
